import Lenis from "lenis";

let lenis = null;
let rafId = null;

export function initLenis() {
    if (typeof window === "undefined") return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    const raf = (time) => {
        lenis?.raf(time);
        rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
}

export function destroyLenis() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    lenis?.destroy();
    lenis = null;
}

export function scrollToId(id) {
    const el = document.querySelector(id);
    if (!el) return;
    if (lenis) {
        lenis.scrollTo(el, { offset: -84, duration: 1.25 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
}

export function scrollTop() {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
}
